export default __webpack_public_path__ + "static/media/chevron_right.ca06203c.svg";